import { connect } from 'react-redux';
import EnterCompliance from '../../../../components/AnnualPlanning/SecondTerm/EnterCompliance.tsx';
import { RootState } from '@/core/types/state';
import {
  focuses,
  objectives,
  activities,
  requirements,
  currentVersion,
  currentFulfillmentVersion,
  readOnlyMode,
  selectedYear,
  scopeName,
  currentPlanId,
  currentBusinessUnit,
  periods,
} from '@/core/selectors';
import {
  createFulfillmentVersion,
  fetchAnnualPlanComplianceContext,
  fetchAnnualPlanStep2Context,
  getPlanValidation,
  reopenPlanVersion,
  setCurrentVersion,
} from '@/core/slices/plans.ts';
import {
  updateActivityProgress,
  uploadActivityEvidenceAction,
  deleteActivityEvidenceAction,
  getActivityEvidenceAction,
  deleteActivityEvidenceFileAction,
} from '@/core/slices/activities';

const ConnectedEnterCompliance = connect(
  (state: RootState) => ({
    objectives: objectives(state),
    activities: activities(state),
    requirements: requirements(state),
    focuses: focuses(state),
    currentVersion: currentVersion(state),
    currentPlanId: currentPlanId(state),
    currentFulfillmentVersion: currentFulfillmentVersion(state),
    readOnlyMode: readOnlyMode(state),
    selectedYear: selectedYear(state),
    scopeName: scopeName(state),
    currentBusinessUnit: currentBusinessUnit(state),
    periods: periods(state),
    planValidation: state.plans.planValidation,
  }),
  {
    fetchAnnualPlanStep2Context,
    fetchAnnualPlanComplianceContext,
    updateActivityProgress,
    uploadActivityEvidence: uploadActivityEvidenceAction,
    deleteActivityEvidence: deleteActivityEvidenceAction,
    getActivityEvidence: getActivityEvidenceAction,
    deleteActivityEvidenceFile: deleteActivityEvidenceFileAction,
    createFulfillmentVersion,
    getPlanValidation,
    reopenPlanVersion,
    setCurrentVersion,
  },
)(EnterCompliance);

export default ConnectedEnterCompliance;
